module.exports = __webpack_public_path__ + "static/media/winchester-7.50b59ba5.svg";